/* Ensure that words that are in grey blocks or not at the top level
are counted */
const getTextFomData = data => {
  if (!data.entityMap) return

  const textBlocks = []
  data?.blocks.forEach(({ text, type }) => {
    text && type !== 'atomic' && textBlocks.push(text)
  })

  Object.values(data.entityMap).forEach(entity => {
    if (entity.data.body) {
      const text = getTextFomData(entity.data.body)
      text && textBlocks.push(...text)
    }
  })

  return textBlocks
}

const getWordCountFromBody = body => {
  if (body.type === 'tinymce') {
    // TODO: Handle tinymce wordcount
    return 0
  }

  return getTextFomData(body.data)
    .join(' ')
    .split(' ').length
}

export { getWordCountFromBody }
